import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { AmountCurrencyPipe } from './currency.pipe';

@Directive({
  selector: '[appParseDecimals]',
  standalone: false,
})
export class ParseDecimalsDirective {
  @Input('decimalSeparator') DECIMAL_SEPARATOR: string;
  @Output('updateDecimals') updateDecimals: EventEmitter<string> = new EventEmitter();

  constructor(
    private amountCurrencyPipe: AmountCurrencyPipe,
    public el: ElementRef,
  ) {
    let langDecimalSeparator: number;
    this.el.nativeElement.onkeypress = (event) => {
      switch (this.DECIMAL_SEPARATOR) {
        case ',':
          langDecimalSeparator = 44;
          break;
        case '.':
          langDecimalSeparator = 46;
          break;
      }
      // Para poder usar las flechas y firefox
      if (event.which === 0 || event.which === 8) {
        return;
      }

      if (
        event.which !== langDecimalSeparator &&
        (event.which < 48 || event.which > 57)
      ) {
        event.preventDefault();
      }
    };

    this.el.nativeElement.onkeyup = (event) => {
      this.updateDecimals.emit(this.el.nativeElement.value);
    };
  }

  @HostListener('blur', ['$event']) blurAction(event): void {
    if (this.el.nativeElement.value) {
      this.el.nativeElement.value = this.amountCurrencyPipe.transform(
        this.el.nativeElement.value,
      );

      if ((<string>this.el.nativeElement.value).startsWith(this.DECIMAL_SEPARATOR)) {
        this.el.nativeElement.value = `0${this.el.nativeElement.value}`;
      }

      // this.updateDecimals.emit(this.el.nativeElement.value);
      this.el.nativeElement.value = this.amountCurrencyPipe.transform(
        this.el.nativeElement.value,
      );
    }
  }

  @HostListener('focus', ['$event']) focusAction(event): void {
    this.el.nativeElement.value = this.amountCurrencyPipe.parse(
      this.el.nativeElement.value,
    );
  }
}
